import { combineReducers } from 'redux';
import user from "./reducers/user";
import booksCUD from "./reducers/booksCUD";
import bookListCUD from "./reducers/bookListCUD";
import AllBooks from "./reducers/AllBooks";
import AllBooklists from "./reducers/AllBooklists";
import SearchBook from "./reducers/SearchBook";
import EditBookForm from "./reducers/EditBookForm";

export default combineReducers ({
    user,
    booksCUD,
    bookListCUD,
    AllBooks,
    AllBooklists,
    SearchBook,
    EditBookForm
});